import { render, staticRenderFns } from "./VisitorFormMenu.vue?vue&type=template&id=086fb38a"
import script from "./VisitorFormMenu.vue?vue&type=script&lang=js"
export * from "./VisitorFormMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports